export default {
	loading: false,
	preferredVendors: [],
	errors: {
		id: '',
		name: false,
		description: false
	},
	carrierVendors: {},
};